export const LANGUAGES = [
  { code: 'ko', label: '한국어', country: 'kr', dateLocale: 'ko-KR' },
  { code: 'en', label: 'English', country: 'us', dateLocale: 'en-US' },
  { code: 'zh', label: '中文', country: 'cn', dateLocale: 'zh-CN' },
  { code: 'ja', label: '日本語', country: 'jp', dateLocale: 'ja-JP' },
  { code: 'th', label: 'ไทย', country: 'th', dateLocale: 'th-TH' },
  { code: 'fr', label: 'Français', country: 'fr', dateLocale: 'fr-FR' },
  { code: 'de', label: 'Deutsch', country: 'de', dateLocale: 'de-DE' },
  { code: 'es', label: 'Español', country: 'es', dateLocale: 'es-ES' },
];

export const getFlagUrl = (country) =>
  `https://flagcdn.com/w40/${country}.png`;

export const SUPPORTED_CODES = LANGUAGES.map((l) => l.code);

export const DEFAULT_LANG = 'ko';
